/* eslint-disable no-unused-vars */
export enum QuoteSide {
  Ask = "Ask",
  Bid = "Bid",
  Both = "Both",
  Mid = "Mid",
  TwoWay = "Two-Way",
}
